import React, { FC, ReactNode } from 'react';
import { ButtonProps } from 'antd/lib/button';
import { Button, message, Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons/lib';
import { useMutation } from 'react-query';
import { DevicesAPI } from 'api/DevicesAPI';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { DeleteOutlined } from '@ant-design/icons';

const translationKey = 'devices.delete';

export interface DeleteDeviceButtonProps
  extends Omit<ButtonProps, 'onClick' | 'loading' | 'href'> {
  device: { id: number; serialNumber: string };
  onDelete?: () => void;
  tooltip?: ReactNode;
}

export const DeleteDeviceButton: FC<DeleteDeviceButtonProps> = ({
  device,
  onDelete,
  ...buttonProps
}) => {
  const [mutate, { isLoading }] = useMutation(DevicesAPI.deleteDevice);
  const intlMessage = useFormatMessage();

  const showConfirm = () =>
    Modal.confirm({
      title: intlMessage(
        { id: `${translationKey}.confirm` },
        {
          serialNumber: device.serialNumber,
        }
      ),
      icon: <ExclamationCircleOutlined />,
      okText: intlMessage({ id: 'yes' }),
      cancelText: intlMessage({ id: 'cancel' }),
      okType: 'danger',
      onOk: () =>
        mutate(device.id, {
          onSuccess: () => {
            message.success(
              intlMessage(
                { id: `${translationKey}.success` },
                {
                  serialNumber: device.serialNumber,
                }
              )
            );
            onDelete && onDelete();
          },
        }),
    });

  return (
    <Button
      id="button-delete-device"
      onClick={showConfirm}
      loading={isLoading}
      icon={<DeleteOutlined />}
      {...buttonProps}
    />
  );
};
